module.exports = __webpack_public_path__ + "img/mail-03.5cca00f4.svg";